var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVariant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.356,
    height: 34.151,
    viewBox: "0 0 25.356 34.151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6667",
    "data-name": "Path 6667",
    d: "M28.76,12.34a.55.55,0,0,1,.55-.55H42.418a.55.55,0,0,1,0,1.1H29.31A.55.55,0,0,1,28.76,12.34Zm.55,5.318H42.418a.55.55,0,0,0,0-1.1H29.31a.55.55,0,1,0,0,1.1Zm5.668,3.665H29.311a.55.55,0,1,0,0,1.1h5.667a.55.55,0,1,0,0-1.1Zm-.734,4.768H29.311a.55.55,0,1,0,0,1.1h4.934a.55.55,0,1,0,0-1.1Zm15.537.64a6.909,6.909,0,0,1-11.556,5.124l-.005,0H25.475a.551.551,0,0,1-.55-.55V5.579a.55.55,0,0,1,.55-.55H30.12V3.518a.55.55,0,0,1,.55-.55h2.254V2.94a2.941,2.941,0,0,1,5.882,0v.027H41.06a.551.551,0,0,1,.55.55V5.029h4.644a.55.55,0,0,1,.55.55V21.05A6.915,6.915,0,0,1,49.781,26.731ZM31.22,6.762h9.289V4.069H38.177a.55.55,0,0,1-.533-.685,1.769,1.769,0,0,0,.062-.443,1.842,1.842,0,1,0-3.621.445.549.549,0,0,1-.533.683H31.22Zm-5.2,23.993H37.242A6.908,6.908,0,0,1,45.7,20.426V6.128H41.608V7.31a.551.551,0,0,1-.55.55H30.669a.55.55,0,0,1-.55-.55V6.128h-4.1V30.755Zm22.656-4.024a5.82,5.82,0,1,0-5.82,5.82A5.829,5.829,0,0,0,48.681,26.731Zm-2.787-2.293-3.369,3.23-2.28-1.822a.55.55,0,0,0-.688.859l2.656,2.125a.553.553,0,0,0,.344.118.546.546,0,0,0,.38-.153l3.716-3.563a.549.549,0,0,0-.759-.794Z",
    transform: "translate(-24.675 0.25)",
    fill: "#d1d1d1",
    stroke: "#d1d1d1",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariant);
export default __webpack_public_path__ + "static/media/variant.6b406a0bbfa6c7c052bc244ed1586d0c.svg";
export { ForwardRef as ReactComponent };